import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=1a68fe48&scoped=true&"
import script from "./Room.vue?vue&type=script&lang=js&"
export * from "./Room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68fe48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a68fe48')) {
      api.createRecord('1a68fe48', component.options)
    } else {
      api.reload('1a68fe48', component.options)
    }
    module.hot.accept("./Room.vue?vue&type=template&id=1a68fe48&scoped=true&", function () {
      api.rerender('1a68fe48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sysadmin/Room.vue"
export default component.exports